<template>
  <div class="success-box">
    <div class="mt-5 mb-4">Confirm your shipping address</div>

    <v-radio-group v-model="userSelectedAddress" hide-details>
      <v-row>
        <v-col cols="12" sm="6">
          <v-sheet
            v-bind="addressCardProps('suggestedAddress')"
            @click="setSelectAddress('suggestedAddress', suggestedAddress)"
          >
            <div class="d-flex align-start">
              <!-- <div
                class="custom-radio"
                :class="{ selected-shipping: userSelectedAddress === 'suggestedAddress' }"
              ></div> -->

              <v-radio
                value="suggestedAddress"
                color="primaryText"
                density="compact"
                class="checkout-radio"
              />
              <div>
                <div class="font-weight-bold">Suggested Address</div>
                <div v-if="avalaraAddressResponse?.error" class="warning">
                  We are unable to recognize your shipping address
                </div>
                <div v-else>
                  <div :class="addressLineClass('suggestedAddress')">
                    {{
                      (suggestedAddress?.street || [])
                        .filter((x) => x?.trim())
                        .join(", ")
                    }}
                  </div>
                  <div :class="addressLineClass('suggestedAddress')">
                    {{ suggestedAddress?.city }}, {{ suggestedAddress?.region }}
                    {{ suggestedAddress?.postcode }}
                  </div>
                </div>
              </div>
            </div>
          </v-sheet>
        </v-col>

        <v-col cols="12" sm="6">
          <v-sheet
            v-bind="addressCardProps('originalAddress')"
            @click="setSelectAddress('originalAddress', originalAddress)"
          >
            <div class="d-flex align-start">
              <!-- <div
                class="custom-radio"
                :class="{ selected-shipping: userSelectedAddress === 'originalAddress' }"
              ></div> -->
              <v-radio
                value="originalAddress"
                color="primaryText"
                density="compact"
                class="checkout-radio"
              />
              <div>
                <div class="font-weight-bold">Original Address</div>
                <div :class="addressLineClass('originalAddress')">
                  {{
                    (originalAddress?.street || [])
                      .filter((x) => x?.trim())
                      .join(", ")
                  }}
                </div>
                <div :class="addressLineClass('originalAddress')">
                  {{ originalAddress?.city }}, {{ originalAddress?.region }}
                  {{ originalAddress?.postcode }}
                </div>
              </div>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-radio-group>
  </div>
</template>

<script>
import countries from "@/services/countries";

export default {
  name: "AddressReviewComponent",
  props: ["avalaraAddressResponse"],

  data: () => ({
    userSelectedAddress: "",
  }),

  watch: {
    avalaraAddressResponse: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.setSelectAddress("suggestedAddress", val?.valid_address);
        }
      },
    },
  },

  computed: {
    suggestedAddress() {
      return this.avalaraAddressResponse?.valid_address || {};
    },
    originalAddress() {
      let address = this.avalaraAddressResponse?.original_address || {};
      if (address.country_id) {
        const countryData = countries[address.country_id];
        const region = countryData?.available_regions?.find(
          (r) => r.id == address.region_id
        );
        address.region = region?.name;
      }
      return address;
    },
  },

  methods: {
    addressCardProps(type) {
      const isActive = this.userSelectedAddress === type;
      return {
        border: true,
        rounded: true,
        class: [
          "address-card pa-4 d-flex",
          isActive ? "selected-address text-primaryText" : "",
        ],
      };
    },

    addressLineClass(type) {
      return this.userSelectedAddress === type
        ? "text-primaryText"
        : "fontsize-16";
    },

    setSelectAddress(type, address = {}) {
      this.userSelectedAddress = type;

      if (address.country_id) {
        const countryData = countries[address.country_id];
        const region = countryData?.available_regions?.find(
          (r) => r.id == address.region_id
        );

        const formattedAddress = {
          state: region?.code || "",
          country: address.country_id || "",
          postal_code: address.postcode || "",
          city: address.city || "",
          line1: address.street?.[0] || "",
          line2: address.street?.[1] || "",
        };

        this.$emit("userSelectedAddress", {
          address: formattedAddress,
          name: address.firstname + " " + address.lastname,
          phone: address.telephone,
        });
      } else {
        this.$emit("userSelectedAddress", null);
      }
    },
  },
};
</script>
<style lang="scss">
.address-card {
  border: 1px solid #dfdfdf;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
}

.address-card.selected-address {
  background: #d9e3f6 !important;
  border: 1px solid #3d5788;
  box-shadow: none;
}

/* .custom-radio {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid #2c2e31;
  position: relative;
  cursor: pointer;
  margin-top: 4px;
  margin-right: 3px;
}

.custom-radio.active {
  border: 3px solid #3d5788;
}

.custom-radio.active::after {
  content: "";
  width: 6px;
  height: 6px;
  background: #dae4f8;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
} */
</style>
